import { render, staticRenderFns } from "./emaileditor.vue?vue&type=template&id=684596b7&scoped=true&lang=pug"
import script from "./emaileditor.vue?vue&type=script&lang=js"
export * from "./emaileditor.vue?vue&type=script&lang=js"
import style0 from "./emaileditor.vue?vue&type=style&index=0&id=684596b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684596b7",
  null
  
)

export default component.exports